/*
*
* File JS componente Products Slider
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper, {Navigation} from 'swiper';

Swiper.use([Navigation]);

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './gallery-slider.scss';
import lightGallery from "lightgallery";
import 'lightgallery/css/lightgallery-bundle.min.css';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const gallerySlider = () => {
    let $lgSwiper = document.querySelector('.gallery-lightgallery');
    let isMobile = window.innerWidth < 768;
    let args = {
        slidesPerView: 1,
        speed: 500,
        centeredSlides: true,
        threshold: 20,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            init: function () {
                console.log('isMobile ', isMobile);
                if (isMobile) {
                    const lg = lightGallery($lgSwiper, {
                        thumbnail: false,
                        animateThumb: false,
                        showThumbByDefault: false,
                        download: false,
                        hideBarsDelay: 0,
                        autoplayControls: false,
                        hash: true,
                        escKey: true,
                        keyPress: true,
                        licenseKey: 'WQ63Z-598QW-NZ7D5-WPMTB',
                        mobileSettings: {
                            controls: true,
                            showCloseIcon: true,
                            download: false
                        }
                    });

                    $lgSwiper.addEventListener('lgBeforeClose', () => {
                        gallerySwiper.slideTo(lg.index, 0)
                    });
                }
            },
        }
    };
    let gallerySwipers = document.querySelectorAll('.gallerySwiper');
    gallerySwipers.forEach(el => {
        let gallerySwiper = new Swiper(el, args);
    })
}

export default gallerySlider;

//--------------------------------------------------------------------//